export enum ActivePaymentsTab {
  OVERVIEW = 'overview',
  DETAILS = 'details',
  REVIEW = 'Review',
}

export enum EmployeesTab {
  ALL = 'all',
  REVIEW = 'review',
}
